import useCustomization from '../../hooks/useCustomization';
import LegalDocsMarkdown from '../custom/LegalDocsMarkdown';
import React from 'react';
import { CustomizationKey } from '../../app/slices/customizations.slice';

const IMPRESSUM_KEY: CustomizationKey = 'IMPRINT';

const ImprintModalCustomization = () => {
	const customization = useCustomization(IMPRESSUM_KEY);
	if (!customization) return null;
	return <LegalDocsMarkdown content={customization} />;
};

export default ImprintModalCustomization;
